import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import {
    taskDetailRequest, assignTaskRequest, assignTaskRequestStatus, updateTaskStatusRequest,
    updateTaskStatusRequestStatus, addTaskCommentRequest, addTaskCommentRequestStatus
} from '../../../redux/task/task.action'
import { shiftListRequest } from '../../../redux/shift/shift.action'
import { employeeListRequest } from '../../../redux/employee/employee.action'
import moment from "moment";
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import CommonButton from "../../../components/button/common-button/commonButton";
import Select from 'react-select'
import Modal from 'react-bootstrap/Modal';
import ButtonRow from "../../../components/button/button-row/buttonRow";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const TaskDetail = props => {
    const { user } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { state } = useLocation()
    const { taskDetailSuccess, taskDetailError, updateTaskStatusSuccess, updateTaskStatusError,
        updateTaskStatusReqStatus, assignTaskSuccess, assignTaskError, assignTaskReqStatus,
        addTaskCommentSuccess, addTaskCommentError, addTaskCommentReqStatus } = useSelector(state => state.task)
    const { shiftListSuccess, shiftListError } = useSelector(state => state.shift)
    const { employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    const [selectedEmployee, setSelectedEmployee] = useState(null)
    const [selectedStatus, setSelectedStatus] = useState()
    const [selectedShift, setSelectedShift] = useState()
    const [comment, setComment] = useState('')
    const TASK_STATUS_LIST = [
        { key: APP_CONSTANTS.TASK_STATUS.OPEN, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.TASK_STATUS.OPEN) },
        { key: APP_CONSTANTS.TASK_STATUS.IN_PROGRESS, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.TASK_STATUS.IN_PROGRESS) },
        { key: APP_CONSTANTS.TASK_STATUS.HOLD, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.TASK_STATUS.HOLD) },
        { key: APP_CONSTANTS.TASK_STATUS.CLOSED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.TASK_STATUS.CLOSED) },
    ]
    const [showStatusModal, setShowStatusModal] = useState(false)
    const [assignEmployeeModal, setShowAssignEmployeeModal] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')

    useEffect(() => {
        fetchTaskDetail()
    }, [])

    const fetchTaskDetail = () => {
        setLoading(true)
        const data = {
            taskId: state.taskId,
            params: {
                businessId: state.businessId,
                locationId: state.locationId
            }
        }
        dispatch(taskDetailRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(taskDetailSuccess)) {
            setLoading(false)
        } else if (!isEmpty(taskDetailError)) {
            setLoading(false)
        }
    }, [taskDetailSuccess, taskDetailError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    useEffect(() => {
        if (updateTaskStatusReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateTaskStatusSuccess.data.message)
            fetchTaskDetail()
        } else if (updateTaskStatusReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateTaskStatusError.message)
        }
        if (updateTaskStatusReqStatus?.length) {
            dispatch(updateTaskStatusRequestStatus(''))
        }
    }, [updateTaskStatusSuccess, updateTaskStatusError, updateTaskStatusReqStatus])

    useEffect(() => {
        if (addTaskCommentReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(addTaskCommentSuccess.data.message)
            setComment('')
            fetchTaskDetail()
        } else if (addTaskCommentReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addTaskCommentError.message)
        }
        if (addTaskCommentReqStatus?.length) {
            dispatch(addTaskCommentRequestStatus(''))
        }
    }, [addTaskCommentSuccess, addTaskCommentError, addTaskCommentReqStatus])

    useEffect(() => {
        if (assignTaskReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(assignTaskSuccess.data.message)
            fetchTaskDetail()
        } else if (assignTaskReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(assignTaskError.message)
        }
        if (assignTaskReqStatus?.length) {
            dispatch(assignTaskRequestStatus(''))
        }
    }, [assignTaskSuccess, assignTaskError, assignTaskReqStatus])

    const handleUpdateStatusClick = () => {
        if (isEmpty(selectedStatus)) {
            displayErrorToast('Task status not selected')
        } else if (isEmpty(taskDetailSuccess)) {
            displayErrorToast('Task details not found. Please try again')
        } else {
            setLoading(true)
            const data = {
                taskId: state.taskId,
                status: selectedStatus.key
            }
            dispatch(updateTaskStatusRequest(data))
            setShowStatusModal(false)
        }
    }

    const handleAssignClick = (isAssignToMe = false) => {
        if (!isAssignToMe && isEmpty(selectedEmployee)) {
            displayErrorToast('Employee not selected')
        } else if (isEmpty(taskDetailSuccess)) {
            displayErrorToast('Task details not found. Please try again')
        } else {
            let userId
            let userType
            if (isAssignToMe) {
                if (isLoggedInUserBusiness(user)) {
                    userId = user.data.userDetails.userId
                    userType = user.data.userDetails.userType
                } else {
                    userId = user.data.userDetails.employeeId
                    userType = user.data.userDetails.userType
                }
            } else {
                userId = selectedEmployee.employeeId
                userType = selectedEmployee.userType
            }
            const assignedEmp = taskDetailSuccess.data.assignedUserList.find(item => parseFloat(item.id) === userId && item.userType === userType)
            if (!isEmpty(assignedEmp)) {
                displayErrorToast('Employee already assigned on task')
            } else {
                setLoading(true)
                const data = {
                    taskId: state.taskId,
                    userId: userId,
                    userType: userType
                }
                dispatch(assignTaskRequest(data))
            }
        }
    }

    const handleAddCommentClick = () => {
        if (isEmpty(comment)) {
            displayErrorToast('Comment cannot be blank')
        } else if (isEmpty(taskDetailSuccess)) {
            displayErrorToast('Task details not found. Please try again')
        } else {
            setLoading(true)
            const data = {
                taskId: state.taskId,
                comment: comment,
                name: `${user.data.userDetails.firstName} ${user.data.userDetails.lastName}`
            }
            dispatch(addTaskCommentRequest(data))
        }
    }

    const getStatusClassname = (status) => {
        if (status === APP_CONSTANTS.TASK_STATUS.OPEN) {
            return 'pd-status-container td-status-label-blue'
        } else if (status === APP_CONSTANTS.TASK_STATUS.CLOSED) {
            return 'pd-status-container td-status-label-green'
        } else if (status === APP_CONSTANTS.TASK_STATUS.HOLD) {
            return 'pd-status-container td-status-label-red'
        } else if (status === APP_CONSTANTS.TASK_STATUS.IN_PROGRESS) {
            return 'pd-status-container td-status-label-yellow'
        } else {
            return 'pd-status-container td-status-label-dark-green'
        }
    }

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {
            businessId: state.businessId,
            locationId: state.locationId
        }
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(employeeListRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(selectedEmployee)) {
            handleAssignClick()
            setShowAssignEmployeeModal(false)
        }
    }, [selectedEmployee])

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.TASK.ASSIGN_TASK) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.TASK, PERMISSION_SUB_TYPE.TASK.ASSIGN_TASK, state.businessId, state.locationId)
        } else if (pType === PERMISSION_SUB_TYPE.TASK.REMOVE_EMPLOYEE_TASK) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.TASK, PERMISSION_SUB_TYPE.TASK.REMOVE_EMPLOYEE_TASK, state.businessId, state.locationId)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Task Details' />
                {!isEmpty(taskDetailSuccess) && !isEmpty(taskDetailSuccess.data) && <CommonFormBorder>
                    <div className="td-row-container">
                        <div className={getStatusClassname(taskDetailSuccess.data.status)}>{removeSpecialCharAndChangeToPascal(taskDetailSuccess.data.status)}</div>
                        {taskDetailSuccess.data.status !== APP_CONSTANTS.TASK_STATUS.CLOSED && <div className="td-status-row-container margin-left-10" onClick={() => {
                            setShowStatusModal(true)
                        }}>
                            <div className="td-edit-label">Edit</div>
                            <div className="td-edit-icon">
                                <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                            </div>
                        </div>}
                    </div>
                    <div className="pd-name-label">{taskDetailSuccess.data.title}</div>
                    <div className="pd-description-label">{taskDetailSuccess.data.description}</div>
                    {!isEmpty(taskDetailSuccess.data.createdByDetails) && <div className="td-row-container">
                        <div className="td-row-label">Reported By:</div>
                        <div className="td-row-value">{taskDetailSuccess.data.createdByDetails.firstName} {taskDetailSuccess.data.createdByDetails.lastName}</div>
                    </div>}
                    {!isEmpty(taskDetailSuccess.data.createdByDetails) && <div className="td-row-container">
                        <div className="td-row-label">User Type:</div>
                        <div className="td-row-value">{taskDetailSuccess.data.createdByDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.BUSINESS ? 'Business Owner' : removeSpecialCharAndChangeToPascal(taskDetailSuccess.data.createdByDetails.userType)}</div>
                    </div>}
                    <div className="td-row-container">
                        <div className="td-row-label">Reported On: </div>
                        <div className="td-row-value">{moment.utc(taskDetailSuccess.data.createdOn).local().format('DD/MM/YYYY')}</div>
                    </div>
                    <FormFieldLabel label='Assignee' />
                    <div className="td-assignee-row-container">
                        {!isEmpty(taskDetailSuccess.data.assignedUserDetails) && taskDetailSuccess.data.assignedUserDetails.map(item => (
                            <div className="td-a-row-item">
                                <div className="td-a-row-item-label">{item.firstName} {item.lastName}</div>
                                <div className="td-a-row-item-label">{item.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? `${item.employeeBusinessMapping[0].employeeCode}` : `${removeSpecialCharAndChangeToPascal(item.userType)}`}</div>
                            </div>
                        ))}
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.TASK.ASSIGN_TASK) && <div className="td-a-row-item td-a-row-item-center" onClick={() => setShowAssignEmployeeModal(true)}>
                            <div className="td-row-icon-container">
                                <img src={require('../../../assets/ic_user_add.png')} className="img" />
                            </div>
                            <div className="td-a-row-placeholder-label">Add More</div>
                        </div>}
                    </div>
                    <FormFieldLabel label='Comments' />
                    {isEmpty(taskDetailSuccess.data.comments) && <div className="content-error">No Comments Found!</div>}
                    {!isEmpty(taskDetailSuccess.data.comments) && <div className="td-comment-col-container">
                        {taskDetailSuccess.data.comments.map(item => (<div className="td-comment-item-container">
                            <div className="td-comment-date">{moment.utc(item.date).local().format('DD/MM/YYYY')}</div>
                            <div className="td-comment">{item.comment}</div>
                            <div className="td-comment-name">{item.name}</div>
                        </div>))}
                    </div>}
                    <CommonInputFloatFull
                        type='text'
                        id='comments'
                        onChange={e => setComment(e.target.value)}
                        placeholder='Enter new comment'
                        value={comment}
                        rows={2}
                        multiline={true} />
                    <div className="td-comment-btn-container">
                        <CommonButton
                            label='Submit Comment'
                            onClick={() => { handleAddCommentClick() }} />
                    </div>
                </CommonFormBorder>}
                {!isEmpty(taskDetailError) && <div className="content-error">{taskDetailError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowStatusModal(false) }}
                show={showStatusModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Select task status
                </Modal.Header>
                <Modal.Body>
                    {!isEmpty(TASK_STATUS_LIST) && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={selectedStatus}
                        getOptionLabel={e => `${e.value}`}
                        getOptionValue={e => e}
                        options={TASK_STATUS_LIST}
                        placeholder='Select Status'
                        onChange={e => {
                            setSelectedStatus(e)
                        }} />}
                    <div className="td-comment-btn-container">
                        <CommonButton isInverted={true} onClick={() => handleUpdateStatusClick()} label='Update Status' />
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowAssignEmployeeModal(false) }}
                show={assignEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Select employee
                </Modal.Header>
                <Modal.Body>
                    <div className="ol-search-parent-container">
                        <div className="ol-search-row-parent-container">
                            <div className="ol-search-input-container">
                                <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Employee" />
                            </div>
                            <div className="ol-search-icon-container" onClick={() => { fetchEmployeeList() }}>
                                <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                            </div>
                        </div>
                    </div>
                    {!isEmpty(employeeListSuccess) && <div className="ae-emp-list-container">
                        {!isEmpty(employeeListSuccess.data) && employeeListSuccess.data.map(e => (<div className="ae-emp-list-item-container">
                            <div className="ae-emp-list-item-content-container">
                                <div className="ae-emp-name-label">{e.firstName} {e.lastName}</div>
                                <div className="ae-emp-code-label">{e.employeeCode}</div>
                                <div className="ae-emp-name-label">{e.role}</div>
                            </div>
                            <div className="ae-row-btn-container" onClick={() => {
                                setSelectedEmployee(e)
                            }}>Assign</div>
                        </div>))}
                    </div>}
                    {!isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                    <div className="td-or-label">OR</div>
                    <div className="td-or-btn-container">
                        <CommonButton label='Assign to me' onClick={() => { handleAssignClick(true) }} />
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default TaskDetail